import { INITIAL_LEAD } from '../../utils/constants';

export default function () {
  return {
    data: { ...INITIAL_LEAD },
    leadLoading: false
  };
}
